export const mondayAbbreviatedLowercase = "cj$5d";
export default {mondayAbbreviatedLowercase};